import React from "react";
import { Link } from "react-router-dom";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import DefaultNotFound from "../../Misc/DefaultNotFound";
import EssenceActionsDropdown from "../../Essence/EssenceActionsDropdown";
import EssenceStateLabel from "../../Essence/EssenceStateLabel";

export default class MaintClone extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: true,
    };
  }

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.itemId !== this.props.itemId) {
      this.load();
    }
  }

  load = async () => {
    const { shipId, structureId, itemId } = this.props;
    this.setState({ pending: true });
    let result = await this.context.api.q("/maintenance/clone", {
      source: this.props.itemId,
    });
    if (result) {
      this.context.toast("ТО клонировано", "success");
      this.context.redirect(
        `/maint/${result.structure}/${result.ship}/${result.id}/`
      );
      if (this.props.onAfterSave) {
        this.props.onAfterSave(result);
      }
    } else {
      this.context.redirect(`/maint/${structureId}/${shipId}/${itemId}/`);
    }
  };

  render() {
    const { pending } = this.state;
    return (
      <>
        <Blocker on={pending}>
          <div className="alert alert-primary">Клонирование ТО</div>
        </Blocker>
      </>
    );
  }
}
